import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

const ListItem = styled.button`
  padding: ${layout.spacing.xSmall};
  cursor: pointer;
  width: 100%;
  text-align: left;
  white-space: nowrap;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export default ListItem;
